/* eslint-disable */

import React from 'react';
import Loading from '../../components/Loading';
import LoadMoreComponent from '../../components/LoadMoreComponent';

import CheckData from '../../components/CatchError';
import DataTable from '../../components/Datatable';
import { linReg } from '../../lib/reduce';
import { COLUMNS, getStrength } from './keys';
import query from './query';
import ExtraBtns from './extraBtns';
import { scrollForTable } from '../../components/Datatable/utils';
import AdditionalBox from './additionalBox';
import { withTranslation } from 'react-i18next';

const tabs = (t) => [
    {
        icon: 'icon-fi_grid',
        label: t('discover.entities.opportunities.all'),
        key: 'all',
        hint: '',
    },
    {
        icon: 'icon-grid-03',
        key: 'relative-authority',
        label: t('discover.entities.opportunities.relative-authority'),
        hint: "Displaying Top entities that have 10 pages or more ordered by 'Relative Authority'",
    },
    {
        icon: 'icon-file-04',
        key: 'content-production',
        label: t('discover.entities.opportunities.content-production'),
        hint: "Displaying Top entities that have 10 pages or more ordered by 'No. of Pages'",
    },
    {
        icon: 'icon-intersect-circle',
        key: 'engagement',
        label: t('discover.entities.opportunities.engagement'),
        hint: "Displaying Top entities that have 10 pages or more ordered by 'CTR (Engagement)'",
    },
    {
        icon: 'icon-arrows-right',
        key: 'striking-distance',
        label: t('discover.entities.opportunities.striking-distance'),
        hint: '',
    },
];

class Summary extends LoadMoreComponent {
    constructor(props) {
        super();
        this.query = query({});

        this.offsetStep = 500;

        this.getAverages = this.getAverages.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onToggleWiki = this.onToggleWiki.bind(this);
        this.showData = this.showData.bind(this);

        this.images = {
            strong: props.image_strong,
            striking_distance: props.image_striking_distance,
            weak: props.image_weak,
            type: '',
            toggleWiki: false,
        };
    }

    handleTypeChange(value) {
        this.setState({
            type: value,
        });
        this.query = query({ type: value });
        this.setState({ allData: [] });
        this.query.bind(this.setState.bind(this));
        this.query.update();
    }

    getAverages() {
        const data = this.state.allData;
        const length = data?.length ?? 1;
        const sumAll = this.state.allData.reduce((acc, curr, i) => {
            if (i === 0) {
                acc = {
                    sumPages: curr.pages,
                    sumRelevancy: curr.salience,
                    sumImpressions: curr.impressions,
                    sumIpr: curr.ipr,
                    sumCTR: curr.ctr,
                };
            } else {
                acc = {
                    sumPages: acc.sumPages + curr.pages,
                    sumRelevancy: acc.sumRelevancy + curr.salience,
                    sumImpressions: acc.sumImpressions + curr.impressions,
                    sumIpr: acc.sumIpr + curr.ipr,
                    sumCTR: i < 100 ? acc.sumCTR + curr.ctr : acc.sumCTR,
                };
            }
            return acc;
        }, {});
        const averages = {
            avgPages: sumAll.sumPages / length,
            avgImpressions: sumAll.sumImpressions / length,
            avgRelevancy: sumAll.sumRelevancy / length,
            avgIpr: sumAll.sumIpr / length,
            avgCTR: length < 100 ? sumAll.sumCTR / length : sumAll.sumCTR / 100,
        };
        return averages;
    }

    onToggle(value) {
        if (value === 'all') {
            this.setState({
                sortedByToggle: false,
                sortedData: [],
            });
        } else if (value === 'striking-distance') {
            this.setState({
                sortedByToggle: true,
                sortedData: this.state.allData.filter((item) => item.pages >= 5 && item.pages <= 9),
            });
        } else {
            this.setState({
                sortedByToggle: true,
                sortedData: this.state.allData.filter((item) => item.pages > 10),
            });
        }
        const sortKeys = {
            all: 'pages',
            'relative-authority': 'impressionsL',
            'content-production': 'pages',
            engagement: 'ctr',
            '"striking-distance"': 'pages',
        };
        const key = sortKeys[value];

        this.setState({
            toggle: value,
            sortKey: key,
        });
    }

    showData() {
        let data = [];
        if (this.state.sortedByToggle) {
            data = this.state.sortedData;
        } else {
            data = this.state.allData;
        }

        if (this.state.toggleWiki) data = data.filter((item) => item.wiki);

        return data;
    }

    onToggleWiki() {
        this.setState({
            toggleWiki: !this.state.toggleWiki,
        });
    }

    render() {
        const { t } = this.props;
        // if we get less than offsetStep it means we don't have more data
        const showLoadMoreBtn = this.state.data?.length === this.offsetStep;

        const attr = {
            query,
            offsetStep: this.offsetStep,
            type: this.state.type,
        };

        const averages = this.getAverages();
        const sortFns = {
            attr_imp: (array) =>
                array.sort((a, b) => {
                    let a_imp = linReg(a.impressionsL);
                    let b_imp = linReg(b.impressionsL);
                    return a_imp.slope - b_imp.slope;
                }),
            name: (array) => array.sort((a, b) => a.name.localeCompare(b.name)),
            type: (array) => array.sort((a, b) => a.type.localeCompare(b.type)),
            pages: (array) => array.sort((a, b) => a.pages - b.pages),
            action: (array) => array.sort((a, b) => a.salience - b.salience),
            impressionsL: (array) => array.sort((a, b) => a.impressions - b.impressions),
            median_impressions_per_entity: (array) =>
                array.sort(
                    (a, b) => a.median_impressions_per_entity - b.median_impressions_per_entity,
                ),
            ctr: (array) => array.sort((a, b) => a.ctr - b.ctr),
            strength: (array) =>
                array.sort((a, b) => getStrength(a, averages) - getStrength(b, averages)),
        };

        const extraBtns = () => (
            <ExtraBtns
                handleTypeChange={this.handleTypeChange}
                selectedType={this.state.type}
                toggleWiki={this.state.toggleWiki}
                onToggleWiki={this.onToggleWiki}
                t={t}
            />
        );
        const additionalBox = () => (
            <AdditionalBox
                handleTypeChange={this.handleTypeChange}
                selectedType={this.state.type}
                toggleWiki={this.state.toggleWiki}
                onToggleWiki={this.onToggleWiki}
                t={t}
            />
        );

        const data = this.showData();

        return (
            <>
                <div className="card rounded-main overflow-hidden opportunity-box">
                    <div className="card-body">
                        <div className="box-header">
                            {t('discover.entities.opportunities.header')}
                        </div>
                        <div className="opportunity-box-items">
                            {tabs(t).map((item) => (
                                <button
                                    key={item.key}
                                    type="button"
                                    className={`opportunity-box-item ${
                                        (this.state.toggle ?? 'all') === item.key ? 'active' : ''
                                    }`}
                                    title={item.hint}
                                    onClick={() => this.onToggle(item.key)}
                                >
                                    {item.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="card table-main rounded-main overflow-hidden">
                    {this.state.loading && !this.state.loadMore ? (
                        <Loading padding={10} />
                    ) : (
                        <>
                            <CheckData
                                content_id={this.props.content_id}
                                parent_id={this.props.parent_id}
                                data={this.state.allData}
                                loading={this.state.loading}
                                loadMore={this.state.loadMore}
                                customCheck
                                customCheckCondition={!!this.state.type}
                            >
                                <>
                                    <DataTable
                                        nodes={data}
                                        sortFns={sortFns}
                                        COLUMNS={COLUMNS(averages, this.images, t)}
                                        fileName={t('discover.entities.title')}
                                        header={t('discover.entities.title')}
                                        extraBtns={extraBtns}
                                        additionalBox={additionalBox}
                                        defaultSortKey={this.state.sortKey ?? 'pages'}
                                        forceRun={this.forceRun}
                                        showLoadMoreBtn={showLoadMoreBtn}
                                        loadMoreLoading={this.state.loadMore}
                                        loadMore={() => this.loadMore(attr)}
                                        additionalStyles={{
                                            Table: `
                                                --data-table-library_grid-template-columns : minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(100px, 1fr) !important;
                                                ${scrollForTable}
                                            `,
                                            BaseCell: `  font-family: 'Raleway';
                                                font-weight: 500;
                                                font-size: 16px;
                                                line-height: 19px;
                                                padding: 16px 10px;
                                                color: #0D182C;
                                            
                                            
                                                &.underline {
                                                text-decoration: underline;
                                                }`,
                                        }}
                                    />
                                </>
                            </CheckData>
                        </>
                    )}
                </div>
            </>
        );
    }
}

export default withTranslation()(Summary);
